<script>
import options from './StafetDeltagPaaHoldFlow.options'
export default options
</script>

<template>
  <article class="kb-stafet-join-a-team-flow">
    <StafetHeader
      :steps="headerSteps"
      :title="labels.title"
      :description="labels.description"
    />

    <div class="kb-stafet-donation-flow__step">
      <component
        :is="currentStepName"
        :labels="labels"
        :nextStepCallback="nextStepCallback"
        :skipStepCallback="skipStepCallback"
        :previousStepCallback="previousStepCallback"
        :displayInputError="displayInputError"
        :submitCallback="submitCallback"
        :stafetId="stafetId"
        :holdId="holdId"
        :tshirtSizes="tshirtSizes"
        :donationAmounts="donationAmounts"
        :redirectToEditProfile="redirectToEditProfile"
        :editProfileLinkText="editProfileLinkText"
        :holdList="holdList"
        :userData="userData"
        :isSubmitting="isSubmitting"
        :loggedIn="loggedIn"
      />
    </div>
  </article>
</template>
